import { render } from "./BodyWrapper.vue?vue&type=template&id=97c916ec"
import script from "./BodyWrapper.vue?vue&type=script&lang=js"
export * from "./BodyWrapper.vue?vue&type=script&lang=js"

import "./BodyWrapper.vue?vue&type=style&index=0&id=97c916ec&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.15.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__